/**
 * Perfil MECÁNICO (mechanical_installation). Subdivisiones + captura por vistas +
 * resumen con conteos; NO registra avance lineal.
 */
export default {
  design: {
    loadFlow:             'subdivisions',  // Configurar → ConfigureSubdivisionsModal
    requiresProcessing:   true,            // subdivisiones OBLIGATORIAS antes de guardar
    generatesBinaryScene: false,           // mecánico no sube .epcb (usa worker de scene)
    captureMode:          'by-views',      // un png por vista
    summaryFields:        ['structures', 'pilings', 'modules', 'panels'],
    screenshotName:       null,            // by-views genera el nombre por vista
    codePrefix:           null,
    views:                ['pilings', 'structures', 'modules', 'panels'],
  },
  progress: {
    linearAdvance: false,                  // mecánico no tiene avance lineal
    advanceModal:  null,
  },
  // Modal de INFO de capa: el mecánico mide por CONTEO de elementos → total de
  // elementos + conteo por estado (no por longitud). Mismo criterio en diseño
  // y en avance.
  layerInfo: {
    metric: 'count',
  },
}
